var $ = require('../internals/export');
var sign = require('../internals/math-sign');

// `Math.sign` method
// https://tc39.github.io/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/es.math.sign.js
// module id = xLUE
// module chunks = 04af